import dictionaryEntity from '~/shared/providers/utils/dictionaryEntity';
import { SharedUpdateAppRepository } from '../repositories/app';

class UpdateBaseService {
  constructor() {
    this.sharedUpdateAppRepository = new SharedUpdateAppRepository();
  }

  async execute({ entityName = '', dataObj = {}, parser }) {
    try {
      const baseData = await this.sharedUpdateAppRepository.update({
        entityName,
        dataObj,
        parser,
      });

      return baseData;
    } catch (error) {
      const errors = {
        ...error,
        title: `Error ao atualizar ${
          dictionaryEntity({
            entityName,
          }) || 'Dados'
        }`,
        local: `StoreBaseServiceExecute`,
      };

      throw errors;
    }
  }
}

export default UpdateBaseService;
